var React = require('react');

function Flashlight (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".fa-secondary{opacity:.4}")),React.createElement("path",{"d":"M400.13 149.25L384 160H32a32 32 0 0 0-32 32v128a32 32 0 0 0 32 32h352l16.13 10.75A317 317 0 0 0 576 416V96a317 317 0 0 0-175.87 53.25zM288 288h-32a32 32 0 0 1 0-64h32a32 32 0 0 1 0 64z","className":"fa-secondary","key":1}),React.createElement("path",{"d":"M608 96h-32v320h32a32 32 0 0 0 32-32V128a32 32 0 0 0-32-32zM288 224h-32a32 32 0 0 0 0 64h32a32 32 0 0 0 0-64z","className":"fa-primary","key":2})]);
}

Flashlight.defaultProps = {"viewBox":"0 0 640 512","className":"icon"};

module.exports = Flashlight;

Flashlight.default = Flashlight;
